import axios from 'axios'
import { getChannelId, handleChannelErrorResponse } from './channelHeader'

const token = localStorage.getItem('store') ?? ''

const instance = axios.create({
	baseURL: process.env.REACT_APP_ENITURE_API_URL,
	headers: {
		authorization: `Bearer ${token}`,
	},
})

// Read fresh per-request so a channel switch takes effect immediately, unlike
// the authorization header above which is fixed at import time.
instance.interceptors.request.use(config => {
	const channelId = getChannelId()
	if (channelId) {
		config.headers['X-Channel-Id'] = channelId
	}
	return config
})

instance.interceptors.response.use(
	response => response,
	error => {
		handleChannelErrorResponse(error)
		return Promise.reject(error)
	}
)

export default instance
